import axios from '../../../commons/gdprcontrol-axios'

const errorReportSkeleton = {
  id: null,
  organization: {id: null, name: ''},
  creator: {id: null, name: ''},
  title: '',
  description: '',
  state: '',
  attachments: [],
  comments: [],
  created_at: ''
}

const state = {
  errorReport: Object.assign({}, errorReportSkeleton),
  pendingAttachments: []
}

const getters = {
  getErrorReport: state => state.errorReport,
  getPendingAttachments: state => state.pendingAttachments
}

const actions = {
  fetchErrorReport: async ({ commit }, errorReportId) => {
    return axios.get(`/api/error-report/${errorReportId}/`)
      .then(response => {
        commit('storeErrorReport', response.data)
      })
      .catch(error => {
        alert('Hiba a műszaki hibabejelentés letöltése közben')
        throw error
      })
  },

  saveNewErrorReport: async ({ commit, state, dispatch }) => {
    return axios.post('/api/error-report/', state.errorReport)
      .then(response => {
        commit('storeErrorReport', response.data)
        dispatch('uploadPendingAttachments')
      })
      .catch(error => {
        alert('Hiba a műszaki hibabejelentés mentése közben')
        throw error
      })
  },

  updateErrorReport: async ({ commit, state, dispatch }) => {
    return axios.put(`/api/error-report/${state.errorReport.id}/`, state.errorReport)
      .then(response => {
        commit('storeErrorReport', response.data)
        dispatch('uploadPendingAttachments')
      })
      .catch(error => {
        alert('Hiba a műszaki hibabejelentés mentése közben')
        throw error
      })
  },

  uploadPendingAttachments: async ({ commit, state, dispatch }) => {
    while (state.pendingAttachments.length > 0) {
      const attachment = state.pendingAttachments[0]
      commit('popPendingAttachment')
      await dispatch('uploadAttachment', attachment)
    }
  },

  uploadAttachment: async ({ commit, state }, attachment) => {
    const data = new FormData()
    data.append('name', attachment.name)
    data.append('document', attachment.file)

    const config = {
      headers: {'Content-Type': 'multipart/form-data'}
    }

    console.log(data)
    return axios.post(`/api/error-report/${state.errorReport.id}/mellekletek/`, data, config)
      .then(response => {
        commit('addAttachment', response.data)
      })
  },

  submitErrorReport: async ({ commit, state }) => {
    return axios.post(`/api/error-report/${state.errorReport.id}/bekuldes/`)
      .then(response => {
        commit('storeErrorReport', response.data)
      })
      .catch(error => {
        alert('Hiba a műszaki hibabejelentés beküldése közben')
        throw error
      })
  },

  investigateErrorReport: async ({ commit, state }) => {
    return axios.post(`/api/error-report/${state.errorReport.id}/vizsgalat/`)
      .then(response => {
        commit('storeErrorReport', response.data)
      })
      .catch(error => {
        alert('Hiba a műszaki hibabejelentés vizsgálat alá helyezése közben')
        throw error
      })
  },

  rejectErrorReport: async ({ commit, state }) => {
    return axios.post(`/api/error-report/${state.errorReport.id}/elutasitas/`)
      .then(response => {
        commit('storeErrorReport', response.data)
      })
      .catch(error => {
        alert('Hiba a műszaki hibabejelentés elutasítása közben')
        throw error
      })
  },

  resolveErrorReport: async ({ commit, state }) => {
    return axios.post(`/api/error-report/${state.errorReport.id}/megoldas/`)
      .then(response => {
        commit('storeErrorReport', response.data)
      })
      .catch(error => {
        alert('Hiba a műszaki hibabejelentés megoldása közben')
        throw error
      })
  },

  sendComment: async ({ commit, state }, comment) => {
    return axios.post(`/api/error-report/${state.errorReport.id}/uj-komment/`, comment)
      .then(response => {
        commit('addComment', response.data)
      })
      .catch(error => {
        alert('Hiba a műszaki hibabejelentéshez tartozó komment mentése közben')
        throw error
      })
  }
}

const mutations = {
  storeErrorReport (state, errorReport) {
    state.errorReport = errorReport
  },

  setAttribute (state, { name, value }) {
    state.errorReport[name] = value
  },

  resetErrorReport (state) {
    state.errorReport.organization = {id: null, name: ''}
    state.errorReport.creator = {id: null, name: ''}
    state.errorReport.attachments = []
    state.errorReport.comments = []
    state.errorReport = Object.assign({}, errorReportSkeleton)
  },

  addPendingAttachment (state, pendingAttachment) {
    state.pendingAttachments.push(pendingAttachment)
  },

  popPendingAttachment (state) {
    state.pendingAttachments.splice(0, 1)
  },

  addAttachment (state, attachment) {
    state.errorReport.attachments.push(attachment)
  },

  addComment (state, comment) {
    state.errorReport.comments.unshift(comment)
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/errorReports/details.js